import {
  CATALOGS_APP_URL,
  CATALOG_COLLECTIONS_APP_URL,
  CATALOGS_NAME,
  COLLECTIONS_NAME,
} from './catalogConstants';

export const CATALOGS = {
  key: CATALOGS_NAME,
  content: CATALOGS_NAME,
  href: CATALOGS_APP_URL,
  link: true,
};

export const COLLECTIONS = {
  key: COLLECTIONS_NAME,
  content: COLLECTIONS_NAME,
  href: CATALOG_COLLECTIONS_APP_URL,
  link: true,
};
